import { render, staticRenderFns } from "./PrmDrafts.vue?vue&type=template&id=27d8c3bd&"
import script from "./PrmDrafts.vue?vue&type=script&lang=js&"
export * from "./PrmDrafts.vue?vue&type=script&lang=js&"
import style0 from "./PrmDrafts.vue?vue&type=style&index=0&id=27d8c3bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports